import { BankConnectionLinkedNotificationMapper } from '@core/mapper/bankConnectionLinkedNotificationMapper';
import { Bad } from '@core/model/framework/Result/BadResult';
import { Ok } from '@core/model/framework/Result/OkResult';
import {
  WaitOnWebauthNotificationGateway,
  WaitOnWebauthNotificationGatewayOutput,
} from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import { BankConnectionLinkedNotification } from '@core/service/digital-factory/bank/types/signalRNotifications';
import { SignalR } from '../../../model/framework/notifications/signalR';

@injectable()
export class WaitOnWebauthNotificationViaSignalR implements WaitOnWebauthNotificationGateway {
  private topicName = 'BANK_CONNECTION_LINKED' as const;

  constructor(
    @inject(SERVICE_ID.signalR) private readonly signalR: SignalR,
    @inject(BankConnectionLinkedNotificationMapper)
    private readonly bankConnectionLinkedNotificationMapper: BankConnectionLinkedNotificationMapper,
    @inject(SERVICE_ID.waitOnWebauthTimeoutInSeconds)
    private readonly timeoutInSeconds: number
  ) {}

  async awaitNewBankConnection(): WaitOnWebauthNotificationGatewayOutput {
    const result = await this.signalR.waitOnSingleNotification(this.topicName, this.timeoutInSeconds);

    if (result.success === false) {
      return Bad('WAITED_NEW_BANK_CONNECTION_FOR_TOO_LONG');
    }

    const notification = result.value as BankConnectionLinkedNotification;
    const bankConnection = this.bankConnectionLinkedNotificationMapper.toDomain(notification);

    return Ok(bankConnection);
  }

  stopWaitingNewBankConnection(): void {
    this.signalR.disposeHandler(this.topicName);
  }
}
